import { lazy } from 'react';
import { ORIGIN_TYPES } from './common';

/*ROUTES DEFINITION*/
export const ROUTES = {
  // For Guest Member
  guest: {
    memberValidation: '/',
    premiumHistory: '/premium-history',
    premiumPayments: '/premium-payments',
    autoPayPremiumPayment: '/autopay-premium-payments',
      noPaymentErrorPage: '/no-payments',
    automaticPaymentsSetup: '/automatic-payments-setup',
    paymentDetails: '/details',
    makePayment: '/make-payment',
    reviewPaymentDetails: '/review-payment-details',
    paymentConfirmationScreen: '/confirmation',
    paymentSuccess: '/payment-success',
    termsAndConditions: '/terms-and-conditions',
    allPaymentDetails: '/all-payments',
    paymentFailed: '/payment-failed',
    paymentError: '/payment-error',
    errorScreen: '/error-screen',
    browserIncompatibilityError: '/browser-incompatibility-error',
    pageNotFound: '/page-not-found',
    medicareLanding: '/medicare-plans',
  },
  // For Active Member
  active: {
    memberValidation: '/',
    premiumPayments: '/premium-payments',
    autoPayPremiumPayment: '/autopay-premium-payments',
    paymentDetails: '/details',
    makePayment: '/make-payment',
    memberAuthentication: '/oauth/return',
    reviewPaymentDetails: '/review-payment-details',
    paymentConfirmationScreen: '/confirmation',
    paymentSuccess: '/payment-success',
    termsAndConditions: '/terms-and-conditions',
    allPaymentDetails: '/all-payments',
    paymentFailed: '/payment-failed',
    paymentError: '/payment-error',
    errorScreen: '/error-screen',
    myWallet: '/my-wallet',
    addNewPaymentMethod: '/add-new-payment-method',
    updateWallet: '/update',
    browserIncompatibilityError: '/browser-incompatibility-error',
    viewSchedulePayment: '/view-schedule-payment',
    paymentsHistory: '/payment-history',
    billingHistoryPage: '/billing-history',
    billingHistorySpreadsheetPage: '/billing-history-spreadsheet',
    autoPaySettings: '/auto-pay-settings',
    automaticPaymentsSetup: '/automatic-payments-setup',
    hpsErrorScreen: '/hps-error-screen',
    viewRecentPayment: '/view-payment-details',
    pickYourPlan: '/pick-your-plan',
      noPaymentErrorPage: '/no-payments',
    medicareLanding: '/medicare-plans',
  },
  // For CA Member
  ca: {
    memberValidation: '/internal/login',
    caMemberAuthentication: '/ca/oauth/return',
    dependentAccessDenied: '/dependent-access-denied',
    terminatedAccountAccessDenied: '/terminated-account-access-denied',
    paymentFailed: '/ca/payment-failed',
  },
  aemRoutes: {
    baseRoute: '/v1/route/content',
    specificPageRoute: '/pageContent',
    commonRoute: '/commonComponent',
    userBasedAlert: '/userBasedAlert',
    menuItemsConfig: '/functionalitiesConfig',
  },
  // For binder user
  binderPayNow: {
    binderMakePayment: '/binder/paynow/make-a-payment',
    reviewBinderPaymentDetails: '/review-binder-payment-details',
    binderPayNowConfirmationScreen: '/binder/paynow/confirmation',
    //should be removed on BAM/Binder flow
    binderPayNowLogin: '/binder-pay-now-login',
    binderPayNowMemberAuthentication: '/binder/redirect',
    errorScreen: '/error-screen',
    paymentFailed: '/payment-failed',
    paymentError: '/payment-error',
    binderPaymentSuccess: '/binderPaymentSuccess',
  },
  binderPayLater: {
    applicantBinderPayment: '/binder/applicant-binder-payment',
    binderAllBillDetails: '/binder-all-bills',
    binderPaymentDetails: '/binder-payment-details',
    binderPayLaterConfirmationScreen: '/binder/confirmation',
    binderPayLaterReviewDetails: '/binder/review-payment-details',
    viewBinderScheduledPayment: '/view-binder-schedule-payment',
    binderPayLaterMakePayment: '/binder/make-a-payment',
    binderAutoPaySettings: '/binder/autoPaySettings',
    paymentError: '/payment-error',
    errorScreen: '/error-screen',
    paymentFailed: '/payment-failed',
    applicantBinder: '/binder',
    applicantBinderWithSlash: '/binder/',
  },
  caBinder: {
    applicantBinderPayment: '/internal/binder',
  },
  broker: {
    brokerMemberAuthentication: '/broker-portal',
    autopaySuccess: '/autopay-success',
    termsOfUse: '/broker-terms-of-use',
    accessDenied: '/broker-access-denied',
    getAutoPayment: '/get-auto-payment',
    sessionTimeOut: '/session-timeout',
    loggedOut: '/logged-out',
    errorScreen: '/error-screen',
  },
  // For HealthSpring specific routes
  healthspring: {
    memberAuthentication: '/oauth/return',
    premiumHistory: '/premium-history',
    premiumPayments: '/premium-payments',
    medicareLanding: '/medicare-plans',
    pickYourPlan: '/pick-your-plan',
    autoPayPremiumPayment: '/autopay-premium-payments',
    mapdPayments: '/mapd-payments',
      errorScreen: '/error-screen',
    productSelection: '/product-selection',
    noPaymentErrorPage: '/no-payments',
    medicareSupplementSelectPlan: '/medicare-supplement-select-plan',
  },
};

const activeRoutes = [
  ROUTES.active.premiumPayments,
  ROUTES.active.autoPayPremiumPayment,
  ROUTES.active.paymentDetails,
  ROUTES.active.makePayment,
  ROUTES.active.memberAuthentication,
  ROUTES.active.reviewPaymentDetails,
  ROUTES.active.paymentConfirmationScreen,
  ROUTES.active.paymentSuccess,
  ROUTES.active.allPaymentDetails,
  ROUTES.active.myWallet,
  ROUTES.active.addNewPaymentMethod,
  ROUTES.active.updateWallet,
  ROUTES.active.viewSchedulePayment,
  ROUTES.active.paymentsHistory,
  ROUTES.active.autoPaySettings,
  ROUTES.active.automaticPaymentsSetup,
  ROUTES.active.noPaymentErrorPage,
    ROUTES.active.errorScreen,
  ROUTES.active.billingHistoryPage,
  ROUTES.active.billingHistorySpreadsheetPage,
  ROUTES.active.paymentFailed,
  ROUTES.active.paymentError,
  ROUTES.active.viewRecentPayment,
];

const caRoutes = [
  ROUTES.ca.memberValidation,
  ROUTES.active.paymentDetails,
  ROUTES.active.makePayment,
  ROUTES.active.memberAuthentication,
  ROUTES.ca.caMemberAuthentication,
  ROUTES.active.reviewPaymentDetails,
  ROUTES.active.paymentConfirmationScreen,
  ROUTES.active.paymentSuccess,
  ROUTES.active.allPaymentDetails,
  ROUTES.active.myWallet,
  ROUTES.active.addNewPaymentMethod,
  ROUTES.active.updateWallet,
  ROUTES.active.viewSchedulePayment,
  ROUTES.active.paymentsHistory,
  ROUTES.active.autoPaySettings,
  ROUTES.active.automaticPaymentsSetup,
  ROUTES.active.errorScreen,
  ROUTES.active.billingHistoryPage,
  ROUTES.active.billingHistorySpreadsheetPage,
  ROUTES.active.paymentFailed,
  ROUTES.active.paymentError,
  ROUTES.active.hpsErrorScreen,
  ROUTES.active.viewRecentPayment,
  ROUTES.ca.dependentAccessDenied,
  ROUTES.ca.terminatedAccountAccessDenied,
  ROUTES.active.pickYourPlan,
    ROUTES.active.noPaymentErrorPage,

];

const caTermedRoutes = [
  ROUTES.ca.memberValidation,
  ROUTES.active.paymentDetails,
  ROUTES.ca.caMemberAuthentication,
  ROUTES.active.allPaymentDetails,
  ROUTES.active.makePayment,
  ROUTES.active.reviewPaymentDetails,
  ROUTES.active.myWallet,
  ROUTES.active.addNewPaymentMethod,
  ROUTES.active.updateWallet,
  ROUTES.active.viewRecentPayment,
  ROUTES.active.paymentConfirmationScreen,
  ROUTES.active.paymentSuccess,
  ROUTES.active.paymentsHistory,
  ROUTES.active.autoPaySettings,
  ROUTES.active.automaticPaymentsSetup,
  ROUTES.active.billingHistoryPage,
  ROUTES.active.billingHistorySpreadsheetPage,
  ROUTES.active.errorScreen,
  ROUTES.active.paymentFailed,
  ROUTES.active.paymentError,
  ROUTES.active.hpsErrorScreen,
  ROUTES.active.pickYourPlan,
    ROUTES.active.noPaymentErrorPage,
];

const guestRoutes = [
  ROUTES.guest.premiumPayments,
  ROUTES.guest.autoPayPremiumPayment,
  ROUTES.guest.paymentDetails,
  ROUTES.guest.makePayment,
  ROUTES.guest.allPaymentDetails,
  ROUTES.guest.paymentConfirmationScreen,
  ROUTES.guest.paymentSuccess,
  ROUTES.guest.reviewPaymentDetails,
  ROUTES.guest.automaticPaymentsSetup,
  ROUTES.guest.errorScreen,
  ROUTES.guest.paymentFailed,
  ROUTES.guest.paymentError,
    ROUTES.active.noPaymentErrorPage,
];

const brokerRoutes = [...guestRoutes, ROUTES.active.autoPaySettings];

// Limited access routes for active users
const limitedAccessActiveRoutes = [
  ROUTES.active.memberAuthentication,
  ROUTES.active.allPaymentDetails,
  ROUTES.active.paymentDetails,
  ROUTES.active.makePayment,
  ROUTES.active.reviewPaymentDetails,
  ROUTES.active.paymentSuccess,
  ROUTES.active.paymentConfirmationScreen,
  ROUTES.active.errorScreen,
  ROUTES.active.paymentFailed,
  ROUTES.active.paymentError,
];

const govtActiveRoutes = [
  ROUTES.active.paymentDetails,
  ROUTES.active.makePayment,
  ROUTES.active.memberAuthentication,
  ROUTES.active.reviewPaymentDetails,
  ROUTES.active.paymentConfirmationScreen,
  ROUTES.active.paymentSuccess,
  ROUTES.active.allPaymentDetails,
  ROUTES.active.myWallet,
  ROUTES.active.addNewPaymentMethod,
  ROUTES.active.updateWallet,
  ROUTES.active.paymentsHistory,
  ROUTES.active.automaticPaymentsSetup,
  ROUTES.active.errorScreen,
  ROUTES.active.billingHistoryPage,
  ROUTES.active.paymentFailed,
  ROUTES.active.paymentError,
  ROUTES.active.viewSchedulePayment,
    ROUTES.active.noPaymentErrorPage,
  // ROUTES.active.viewRecentPayment,
];

const caGovRoutes = [
  ROUTES.ca.memberValidation,
  ROUTES.ca.caMemberAuthentication,
  ROUTES.ca.terminatedAccountAccessDenied,
  ROUTES.active.pickYourPlan,
  ...govtActiveRoutes,
];

export const changePlanViewExceptionRoutes = [
  ROUTES.active.viewRecentPayment,
  ROUTES.active.billingHistorySpreadsheetPage,
  ROUTES.active.autoPaySettings,
];

export const paymentHistoryRoutes = [
  ROUTES.active.paymentsHistory,
  ROUTES.active.viewSchedulePayment,
];

export const billingHistoryRoutes = [
  ROUTES.active.billingHistoryPage,
  ROUTES.active.billingHistorySpreadsheetPage,
];

export const myWalletRoutes = [
  ROUTES.active.myWallet,
  ROUTES.active.updateWallet,
  ROUTES.active.addNewPaymentMethod,
];

export const schedulePaymentRoutes = [ROUTES.active.viewSchedulePayment];

// routeMap to be used in protected routes to verify,
// if the user can access the protected routes or not as per the origin type.
export const routeMap: any = {
  [ORIGIN_TYPES.NMA]: activeRoutes,
  [ORIGIN_TYPES.UMA]: activeRoutes,
  [ORIGIN_TYPES.BAM]: activeRoutes,
  [ORIGIN_TYPES.PUBLICSITE]: activeRoutes,
  [ORIGIN_TYPES.GUEST]: [
    ...guestRoutes,
    ROUTES.binderPayLater.applicantBinderPayment,
    ROUTES.binderPayLater.applicantBinder,
    ROUTES.binderPayLater.applicantBinderWithSlash,
    ROUTES.binderPayNow.binderPayNowLogin, // comment before production, only during dev, don't remove this comment
    ROUTES.binderPayNow.binderPayNowMemberAuthentication,
    ROUTES.broker.brokerMemberAuthentication,
    ROUTES.broker.termsOfUse,
    ROUTES.broker.accessDenied,
    ROUTES.broker.loggedOut,
    ROUTES.guest.medicareLanding,
  ],
  [ORIGIN_TYPES.MMA]: [...activeRoutes, ROUTES.active.pickYourPlan, ROUTES.active.medicareLanding, ROUTES.healthspring.noPaymentErrorPage],
  [ORIGIN_TYPES.CA]: caRoutes,
  [ORIGIN_TYPES.CA_GOVT_USER]: caGovRoutes,
  [ORIGIN_TYPES.BINDER_PAY_NOW]: [
    ROUTES.binderPayNow.binderMakePayment,
    ROUTES.binderPayNow.binderPayNowLogin, // comment before production, only during dev, don't remove this comment
    ROUTES.binderPayNow.reviewBinderPaymentDetails,
    ROUTES.binderPayNow.binderPayNowConfirmationScreen,
    ROUTES.binderPayNow.errorScreen,
    ROUTES.binderPayNow.binderPayNowMemberAuthentication,
    ROUTES.binderPayNow.paymentFailed,
    ROUTES.binderPayNow.paymentError,
    ROUTES.binderPayNow.binderPaymentSuccess,
  ],
  [ORIGIN_TYPES.BINDER_PAY_LATER]: [
    ROUTES.binderPayLater.binderPayLaterMakePayment,
    ROUTES.binderPayLater.binderPayLaterConfirmationScreen,
    ROUTES.binderPayLater.binderPaymentDetails,
    ROUTES.binderPayLater.binderAllBillDetails,
    ROUTES.binderPayLater.binderPayLaterReviewDetails,
    ROUTES.binderPayLater.viewBinderScheduledPayment,
    ROUTES.binderPayLater.errorScreen,
    ROUTES.binderPayLater.paymentFailed,
    ROUTES.binderPayLater.paymentError,
    ROUTES.binderPayLater.applicantBinderPayment,
    // TODO: Need to handle for payment api failiure for binder user
    // ROUTES.active.paymentFailed,
    // ROUTES.active.paymentError,
    ROUTES.binderPayLater.binderAutoPaySettings,
    ROUTES.binderPayLater.applicantBinder,
    ROUTES.binderPayLater.applicantBinderWithSlash,
  ],
  [ORIGIN_TYPES.CA_BINDER_PAY_LATER]: [
    ROUTES.binderPayLater.binderPayLaterMakePayment,
    ROUTES.binderPayLater.binderPayLaterConfirmationScreen,
    ROUTES.binderPayLater.binderPaymentDetails,
    ROUTES.binderPayLater.binderAllBillDetails,
    ROUTES.binderPayLater.binderPayLaterReviewDetails,
    ROUTES.binderPayLater.viewBinderScheduledPayment,
    ROUTES.binderPayLater.errorScreen,
    // TODO: Need to handle for payment api failiure for binder user
    // ROUTES.active.paymentFailed,
    // ROUTES.active.paymentError,
    ROUTES.binderPayLater.paymentFailed,
    ROUTES.binderPayLater.paymentError,
    ROUTES.binderPayLater.binderAutoPaySettings,
    ROUTES.caBinder.applicantBinderPayment,
    ROUTES.active.hpsErrorScreen,
  ],
  [ORIGIN_TYPES.GUEST_GOVERNMENT]: guestRoutes,
  [ORIGIN_TYPES.CA_TERMED_MEMBER]: caTermedRoutes,
  [ORIGIN_TYPES.ONE_TIME_GOVERNMENT_ACTIVE]: [
    ...govtActiveRoutes,
    ROUTES.active.pickYourPlan,
  ],
  [ORIGIN_TYPES.BAM_GOVERNMENT_ACTIVE]: govtActiveRoutes,
  [ORIGIN_TYPES.BROKER]: [
    ...brokerRoutes,
    ROUTES.broker.brokerMemberAuthentication,
    ROUTES.broker.autopaySuccess,
    ROUTES.broker.termsOfUse,
    ROUTES.broker.accessDenied,
    ROUTES.broker.sessionTimeOut,
    ROUTES.broker.loggedOut,
  ],
};

export const limitedAccessRouteMap: any = {
  [ORIGIN_TYPES.MMA]: limitedAccessActiveRoutes,
};

// Read only view routes for active users
const readOnlyViewActiveRoutes = [
  ROUTES.active.memberAuthentication,
  ROUTES.active.allPaymentDetails,
  ROUTES.active.paymentDetails,
  ROUTES.active.autoPaySettings,
  ROUTES.active.myWallet,
  ROUTES.active.paymentsHistory,
  ROUTES.active.billingHistoryPage,
  ROUTES.active.billingHistorySpreadsheetPage,
  ROUTES.active.errorScreen,
  ROUTES.active.paymentFailed,
  ROUTES.active.paymentError,
];

export const readOnlyViewRouteMap: any = {
  [ORIGIN_TYPES.BAM]: readOnlyViewActiveRoutes,
  [ORIGIN_TYPES.MMA]: readOnlyViewActiveRoutes,
};

// Add binder pay now and caBinder routes to appRoutes to handle the protected routes.
export const appRoutes = [
  {
    path: [
      ROUTES.guest.autoPayPremiumPayment,
      ROUTES.active.autoPayPremiumPayment,
    ],
    component: lazy(() => import('../containers/autoPayPremiumPaymentPage')),
  },
  {
    path: [
      ROUTES.guest.automaticPaymentsSetup,
      ROUTES.active.automaticPaymentsSetup,
    ],
    component: lazy(() => import('../containers/automaticPaymentsSetupPage')),
  },
  {
    path: [ROUTES.guest.premiumPayments, ROUTES.active.premiumPayments],
    component: lazy(() => import('../containers/premiumPaymentsPage')),
  },
  {
    path: [ROUTES.guest.paymentDetails, ROUTES.active.paymentDetails],
    component: lazy(() => import('../containers/paymentDetails')),
  },
  {
    path: [
      ROUTES.guest.errorScreen,
      ROUTES.active.errorScreen,
      ROUTES.binderPayLater.errorScreen,
    ],
    component: lazy(() => import('../components/common/ErrorScreen')),
  },
  {
    path: [ROUTES.guest.makePayment, ROUTES.active.makePayment],
    component: lazy(() => import('../containers/makePayment')),
  },
  {
    path: [
      ROUTES.guest.reviewPaymentDetails,
      ROUTES.active.reviewPaymentDetails,
    ],
    component: lazy(() => import('../containers/reviewPaymentDetails')),
  },
  {
    path: [
      ROUTES.guest.paymentConfirmationScreen,
      ROUTES.active.paymentConfirmationScreen,
    ],
    component: lazy(() => import('../containers/paymentConfirmationPage')),
  },
  {
    path: [ROUTES.guest.paymentSuccess, ROUTES.active.paymentSuccess],
    component: lazy(() => import('../containers/paymentSuccessPage')),
  },
  {
    path: [ROUTES.guest.allPaymentDetails, ROUTES.active.allPaymentDetails],
    component: lazy(() => import('../containers/allPaymentDetails')),
  },
  {
    path: [ROUTES.active.myWallet],
    component: lazy(() => import('../containers/myWalletsPage')),
  },
  {
    path: [ROUTES.active.updateWallet],
    component: lazy(() => import('../containers/updateWalletPage')),
  },
  {
    path: [ROUTES.active.addNewPaymentMethod],
    component: lazy(() => import('../containers/addNewPaymentMethodPage')),
  },
  {
    path: [ROUTES.active.hpsErrorScreen],
    component: lazy(
      () => import('../components/common/HpsManagedMemberErrorScreen'),
    ),
  },
  {
    path: ROUTES.binderPayLater.applicantBinder,
    component: lazy(() => import('../components/common/BinderRedirection')),
  },
  {
    path: ROUTES.binderPayLater.applicantBinderWithSlash,
    component: lazy(() => import('../components/common/BinderRedirection')),
  },
  {
    path: ROUTES.active.paymentsHistory,
    component: lazy(() => import('../containers/paymentHistoryPage')),
  },
  {
    path: [ROUTES.active.viewSchedulePayment],
    component: lazy(() => import('../containers/viewScheduledPayments')),
  },
  {
    path: [ROUTES.active.autoPaySettings],
    component: lazy(() => import('../containers/autoPaySettingsPage')),
  },
  {
    path: [ROUTES.broker.autopaySuccess],
    component: lazy(() => import('../containers/autoPaySuccessPage')),
  },
  {
    path: [ROUTES.active.viewRecentPayment],
    component: lazy(() => import('../containers/viewPaymentDetails')),
  },
  {
    path: [ROUTES.active.pickYourPlan],
    component: lazy(() => import('../containers/pickYourPlan')),
  },
  {
    path: [ROUTES.guest.medicareLanding, ROUTES.active.medicareLanding],
    component: lazy(() => import('../containers/medicareLandingPage')),
  },
  {
    path: [ROUTES.broker.accessDenied],
    component: lazy(() => import('../components/common/NoAccess')),
  },
  {
    path: [ROUTES.broker.sessionTimeOut],
    component: lazy(() => import('../containers/sessionTimeOutPage')),
  },
  {
    path: [ROUTES.broker.loggedOut],
    component: lazy(() => import('../components/common/LoggedOut')),
  },
];

/**
 * HealthSpring-specific routes
 * Completely isolated from BCBS routes
 * Conditionally rendered in App.tsx based on brandCode
 * Note: memberAuthentication is needed for OAuth callback handling
 */
export const healthspringRoutes = [
  {
    path: [ROUTES.healthspring.memberAuthentication],
    component: lazy(() => import('../containers/memberAuthentication')),
  },
  {
    path: [ROUTES.healthspring.pickYourPlan],
    component: lazy(() => import('../containers/selectPlanPage')),
  },
  {
    path: [ROUTES.healthspring.autoPayPremiumPayment],
    component: lazy(() => import('../containers/autoPayPremiumPaymentPage')),
  },
  {
    path: [ROUTES.guest.automaticPaymentsSetup],
    component: lazy(() => import('../containers/automaticPaymentsSetupPage')),
  },
  {
    path: [ROUTES.healthspring.premiumPayments],
    component: lazy(() => import('../containers/premiumPaymentsPage')),
  },
  {
    path: [ROUTES.healthspring.mapdPayments],
    component: lazy(() => import('../containers/mapdPaymentsPage')),
  },
  {
    path: [ROUTES.healthspring.medicareSupplementSelectPlan],
    component: lazy(() => import('../containers/medicareSupplementSelectPlanPage')),
  },
  {
    path: [ROUTES.healthspring.premiumHistory],
    component: lazy(() => import('../containers/premiumPaymentHistory')),
  },
  {
    path: [ROUTES.healthspring.medicareLanding],
    component: lazy(() => import('../containers/medicareLandingPage')),
  },
  {
    path: [ROUTES.healthspring.noPaymentErrorPage],
    component: lazy(() => import('../containers/noPaymentErrorPage')),
  },
  {
    path: [ROUTES.healthspring.errorScreen],
    component: lazy(() => import('../components/common/HealthspringErrorScreen')),
  },
];

export const binderRoutes = [
  // binder pay now routes
  {
    path: ROUTES.binderPayNow.binderMakePayment,
    component: lazy(
      () => import('../containers/binderPayments/binderMakePayment'),
    ),
  },
  {
    path: ROUTES.binderPayNow.reviewBinderPaymentDetails,
    component: lazy(
      () =>
        import('../containers/binderPayments/reviewBinderPaymentDetailsPage'),
    ),
  },
  {
    path: ROUTES.binderPayNow.binderPayNowConfirmationScreen,
    component: lazy(
      () => import('../containers/binderPayments/binderConfirmationPage'),
    ),
  },
  {
    path: ROUTES.binderPayNow.binderPayNowLogin,
    component: lazy(
      () => import('../containers/binderPayments/LoginBinderPayNowPage'),
    ),
  },
  {
    path: [ROUTES.binderPayNow.binderPaymentSuccess],
    component: lazy(() => import('../containers/binderPaymentSuccess')),
  },
  {
    path: ROUTES.binderPayNow.binderPayNowMemberAuthentication,
    component: lazy(
      () =>
        import('../containers/binderPayments/binderPayNowMemberAuthentication'),
    ),
  },
  // binder pay later routes
  {
    path: ROUTES.binderPayLater.binderPaymentDetails,
    component: lazy(() => import('../containers/paymentDetails')),
  },
  {
    path: ROUTES.binderPayLater.binderAllBillDetails,
    component: lazy(() => import('../containers/allPaymentDetails')),
  },
  {
    path: ROUTES.binderPayLater.binderPayLaterMakePayment,
    component: lazy(
      () => import('../containers/binderPayments/binderMakePayment'),
    ),
  },
  {
    path: ROUTES.binderPayLater.binderAutoPaySettings,
    component: lazy(() => import('../containers/autoPaySettingsPage')),
  },

  {
    path: ROUTES.binderPayLater.binderPayLaterReviewDetails,
    component: lazy(
      () =>
        import('../containers/binderPayments/reviewBinderPaymentDetailsPage'),
    ),
  },
  {
    path: ROUTES.binderPayLater.applicantBinder,
    component: lazy(() => import('../components/common/BinderRedirection')),
  },
  {
    path: ROUTES.binderPayLater.applicantBinderWithSlash,
    component: lazy(() => import('../components/common/BinderRedirection')),
  },
  {
    path: ROUTES.binderPayLater.binderPayLaterConfirmationScreen,
    component: lazy(
      () => import('../containers/binderPayments/binderConfirmationPage'),
    ),
  },

  {
    path: ROUTES.binderPayLater.applicantBinderPayment,
    component: lazy(
      () => import('../containers/binderPayments/applicantBinderPayment'),
    ),
  },

  {
    path: ROUTES.binderPayLater.viewBinderScheduledPayment,
    component: lazy(() => import('../containers/viewScheduledPayments')),
  },
];

/*ROUTES CONFIGURATION*/
export const ROUTES_CONFIG = {
  [ROUTES.guest.memberValidation]: {
    canExit: true,
    canChangeLanguage: true,
    hideMenu: true,
  },
  [ROUTES.healthspring.premiumHistory]: {
    canExit: true,
    canChangeLanguage: false,
  },
  [ROUTES.healthspring.premiumPayments]: {
    canExit: true,
    canLogout: true,
    hideMenu: true,
  },
  [ROUTES.healthspring.autoPayPremiumPayment]: {
    canExit: true,
    canLogout: true,
    hideMenu: true,
  },
  [ROUTES.healthspring.medicareSupplementSelectPlan]: {
    hideMenu: true,
  },
  [ROUTES.healthspring.mapdPayments]: {
    canExit: true,
    canLogout: true,
  },
  [ROUTES.healthspring.productSelection]: {
    canExit: true,
    hideMenu: true,
  },
  [ROUTES.guest.automaticPaymentsSetup]: {
    canExit: true,
    canLogout: true,
  },
  [ROUTES.active.automaticPaymentsSetup]: {
    canExit: true,
    canLogout: true,
  },
  [ROUTES.ca.memberValidation]: {
    canExit: true,
    canChangeLanguage: true,
    hideMenu: true,
  },
  [ROUTES.guest.paymentDetails]: {
    canExit: true,
    canLogout: true,
  },
  [ROUTES.guest.allPaymentDetails]: {
    canExit: true,
    canLogout: true,
  },
  [ROUTES.guest.paymentConfirmationScreen]: {
    canExit: true,
    canLogout: true,
    hideChangeViewPlan: true,
  },
  [ROUTES.guest.paymentFailed]: {
    canExit: true,
    canLogout: true,
  },
  [ROUTES.guest.errorScreen]: {
    canExit: true,
    hideMenu: true,
    canLogout: true,
  },
  [ROUTES.guest.paymentError]: {
    canExit: true,
    canLogout: true,
  },
  //Exit Link is not present in Payment Terms & Conditions as per designs

  [ROUTES.guest.paymentSuccess]: {
    hideFooter: true,
  },
  [ROUTES.active.paymentSuccess]: {
    hideChangeViewPlan: true,
  },
  //Footer is displayed in every page except payment success page

  [ROUTES.guest.browserIncompatibilityError]: {
    canExit: true,
    canChangeLanguage: true,
  },
  [ROUTES.binderPayLater.applicantBinderPayment]: {
    canExit: true,
    canChangeLanguage: true,
    hideMenu: true,
  },
  [ROUTES.caBinder.applicantBinderPayment]: {
    canExit: true,
    canChangeLanguage: true,
    hideMenu: true,
  },
  //can be remobed after BAM/binder flow
  [ROUTES.binderPayNow.binderPayNowLogin]: {
    canExit: true,
    canChangeLanguage: true,
    hideMenu: true,
  },
  [ROUTES.active.errorScreen]: {
    canChangeLanguage: true,
    canLogout: true,
    hideChangeViewPlan: true,
  },
  [ROUTES.active.paymentFailed]: {
    canChangeLanguage: true,
    canLogout: true,
    hideChangeViewPlan: true,
  },
  [ROUTES.active.paymentError]: {
    hideChangeViewPlan: true,
  },
  [ROUTES.ca.dependentAccessDenied]: {
    canChangeLanguage: true,
    canLogout: true,
  },
  [ROUTES.ca.terminatedAccountAccessDenied]: {
    canChangeLanguage: true,
    canLogout: true,
  },
  [ROUTES.active.pickYourPlan]: {
    hideMenu: true,
  },
  [ROUTES.active.makePayment]: {
    hideChangeViewPlan: true,
  },
  [ROUTES.active.reviewPaymentDetails]: {
    hideChangeViewPlan: true,
  },
  [ROUTES.broker.brokerMemberAuthentication]: {
    canExit: false,
    canChangeLanguage: false,
  },
  [ROUTES.broker.accessDenied]: {
    canExit: false,
    canChangeLanguage: false,
  },
  [ROUTES.broker.autopaySuccess]: {
    canExit: true,
  },
  [ROUTES.broker.errorScreen]: {
    canExit: true,
  },
  [ROUTES.healthspring.noPaymentErrorPage]: {
    canExit: true,
    canLogout: true,
    hideMenu: true,
  },
};

export const allRoutes = [
  ...Object.values(ROUTES.guest),
  ...Object.values(ROUTES.active),
  ...Object.values(ROUTES.binderPayNow),
  ...Object.values(ROUTES.binderPayLater),
  ...Object.values(ROUTES.caBinder),
  ...Object.values(ROUTES.ca),
  ...Object.values(ROUTES.broker),
  ...Object.values(ROUTES.healthspring)
];

export const healthspringRoutesList = Object.values(ROUTES.healthspring);